import { mixins, styled } from '@bob/library'

export const Base = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin: 20px 0 10px;
  @media print {
    margin: 0;
    h1 {
      margin: 0;
    }
  }
`

export const Title = styled.h1`
  ${mixins.typography.headlineXl}
  ${mixins.margin.top(20)}
  ${mixins.margin.bottom(30)}
`

export const Text = styled(Base)`
  ${mixins.padding.bottom(10)};
  border-bottom: 1px solid ${({ theme }: { theme: any }) => theme.color.primary};
`

export const InfoWrapper = styled.div`
  display: flex;
  padding: 10px 0 0 0;
`

export const InfoItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  ${mixins.margin.right(40)};
  color: ${({ theme }: { theme: any }) => theme.color.grayDark};

  & > svg {
    ${mixins.margin.right(10)};
    fill: ${({ theme }: { theme: any }) => theme.color.grayDark};
  }
`

export const Product = styled.div`
  color: ${({ theme }: { theme: any }) => theme.color.success};
  @media print {
    display: none;
  }
`
